import { FaFacebookF, FaLinkedinIn, FaTwitter, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaGoogle } from 'react-icons/fa';
import logo from '../assets/Logo-light.png'; // Adjust this path to your actual logo
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="w-[100%] max-w-[1910px] mx-auto">
    <footer className="mt-10 text-sm">
      {/* Main Footer */}
      <div className="py-10 px-4 md:px-8" style={{ backgroundColor: '#353535', color: '#999' }}>
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Column 1: About */}
          <div>
            <img src={logo} alt="AKHSoft Logo" className="w-32 mb-4" />
            <p>
              AKHSoft delivers smart solutions like School ERP, POS, and custom business software with modern UI/UX.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
            <ul class="list-none">
           <li><Link to="/" className="hover:text-white ">Home</Link></li>
  <li><Link to="/about" className="hover:text-white">About Us</Link></li>
  <li><Link to="/services" className="hover:text-white">Services</Link></li>
  <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
  </ul>
          </div>

          {/* Column 3: Social Media */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Follow Us</h3>
            <div className="flex space-x-4 text-lg">
              <a href="https://www.facebook.com/AKHSoft17" className="hover:text-white"><FaFacebookF /></a>
              <a href="https://pe.linkedin.com/company/akhsoft" className="hover:text-white"><FaLinkedinIn /></a>
              <a href="#" className="hover:text-white"><FaGoogle /></a>
            </div>
          </div>

          {/* Column 4: Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <FaPhoneAlt className="text-white-400" />
                <span>+92 343 2998052</span>
              </li>
              <li className="flex items-center space-x-2">
                <FaEnvelope className="text-white-400" />
                <span>info@akhsoft.com</span>
              </li>
              <li className="flex items-center space-x-2">
                <FaMapMarkerAlt className="text-white-400" />
                <span>Karachi, Pakistan</span>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="text-center py-4 text-xs" style={{ backgroundColor: '#303030', color: '#999' }}>
        &copy; {new Date().getFullYear()} AKHSoft. All rights reserved.
      </div>
    </footer>
    </div>
  );
};

export default Footer;